import { Navigate } from 'react-router-dom';

const Root = () => {
    return <Navigate to="/statements/" />;
};

export default Root;
